/**
 * Add a displayName property to a component. This allows storybook to
 * display components that are wrapped in ForwardRef properly.
 */
export function withDisplayName<T>(component: T, displayName: string): T {
  (component as { displayName?: string }).displayName = displayName;
  return component;
}
